import React from "react";
import { motion } from "framer-motion";

export default function Layout({ children }) {
  return (
    <div className="relative min-h-screen w-full overflow-x-hidden overflow-y-auto" style={{ minHeight: "100svh" }}>
      {/* Static background layer */}
      <div
        className="fixed inset-0 bg-gradient-to-br from-gray-900 via-gray-800 to-black -z-10"
        aria-hidden="true"
      />

      {/* Scrollable content */}
      <motion.div
        className="relative h-full text-white w-full"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
      >
        {children}
      </motion.div>
    </div>
  );
}